// src/components/wallet/SparksWallet.tsx


export type NextRewardHint = {
  needXp: number;
  // поддерживаем оба имени поля, чтобы не ломать текущую логику
  reward?: number;
  rewardXp?: number;
};

type Props = {
  open: boolean;
  onClose: () => void;
  balance: number;
  nextReward?: NextRewardHint | null;
};

export default function SparksWallet({
  open,
  onClose,
  balance,
  nextReward = null,
}: Props) {
  if (!open) return null;

  const rewardValue = nextReward
    ? (nextReward.rewardXp ?? nextReward.reward ?? 0)
    : 0;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Кошелёк искорок"
      className="fixed inset-0 z-[110] flex items-center justify-center"
    >
      <div
        className="absolute inset-0 bg-black/40"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="relative z-[111] max-w-md w-full mx-4 rounded-3xl bg-white border border-gray-200 shadow-[0_20px_60px_rgba(0,0,0,0.15)] p-6">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-xl font-semibold">Кошелёк ✨</h3>
          <button
            onClick={onClose}
            className="rounded-full px-3 py-1 text-sm border border-gray-300 hover:bg-gray-50"
            aria-label="Закрыть кошелёк"
          >
            Закрыть
          </button>
        </div>

        <div className="rounded-2xl bg-amber-50 border border-amber-200 p-4 flex items-center gap-3">
          <div className="text-2xl">✨</div>
          <div>
            <div className="text-sm text-gray-600">Баланс</div>
            <div className="text-lg font-semibold tabular-nums">{balance}</div>
          </div>
        </div>

        {nextReward && (
          <div className="mt-4 rounded-xl bg-gray-50 border border-gray-200 p-4 text-sm">
            До следующей награды осталось{" "}
            <span className="font-semibold tabular-nums">{nextReward.needXp}</span>{" "}
            XP. Награда:{" "}
            <span className="font-semibold tabular-nums">{rewardValue}</span> ✨
          </div>
        )}
      </div>
    </div>
  );
}
